import axios from 'axios';
import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import Card from '@mui/material/Card';
import { Stack } from '@mui/material';
import Table from '@mui/material/Table';
import Container from '@mui/material/Container';
import TableBody from '@mui/material/TableBody';
import Typography from '@mui/material/Typography';

import { useRouter } from '../../../../routes/hooks';
import EnrollmentsTableRow from './enrollments-table-row';
import { useBoolean } from '../../../../hooks/use-boolean';
import { useSettingsContext } from '../../../../components/settings';
import { LoadingScreen } from '../../../../components/loading-screen';
import { useTable, TableNoData, TableHeadCustom } from '../../../../components/table';
import { ResponseErrorChecker } from '../../../../universal-components/responseErrorChecker';

const TABLE_HEAD = [
  { id:'', label: 'Provider Name' },
  { id:'', label: 'Payer ID' },
  { id:'', label: 'Payer Name' },
  { id:'', label: 'Enrollment Status' },
  { id:'', label: 'Effective Date' }
]


export default function EnrollmentsTable() {
  const settings = useSettingsContext();
  const { logout } = useAuth0();
  const { replace } = useRouter();
  const table = useTable({defaultDense: false, defaultRowsPerPage:25});
  const hasLoaded = useBoolean(false);
  const [enrollments, setEnrollments] = useState<{
      firstName: string;
      lastName: string;
      payerId: string;
      payerName: string;
      enrollmentStatus: string;
      effectiveDate: string;
  }[]>([]);

  useEffect(() => {
    const getTableData = async () => {
      const response = await ResponseErrorChecker(() => axios.get(`${import.meta.env.VITE_API_URL}/providers/enrollments`), logout, replace);
      if(response !== null) {
        setEnrollments(response.data);
      }
      hasLoaded.onTrue()
    };

    getTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return(
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      { hasLoaded.value ?
      <Card sx={{p:3}}>
        <Stack>
          <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ pb:2 }}>
            <Typography variant="h4" >
              Enrollments
            </Typography>
            { hasLoaded.value && enrollments.length === 0 &&
              <Typography>
                Your enrollment records are unavailable at this time
              </Typography>
            }
          </Stack>

              <Table size='small' sx={{ minWidth: 960 }}>
                <TableHeadCustom
                  headLabel={TABLE_HEAD}
                  rowCount={enrollments.length}
                  order={table.order}
                  orderBy={table.orderBy}
                  onSort={table.onSort}
                />
                <TableBody>
                  {enrollments.map((enrollment) => (
                    <EnrollmentsTableRow
                      enrollment={enrollment}
                    />
                  ))}
                </TableBody>
                <TableNoData notFound={!hasLoaded.value || (hasLoaded.value && enrollments.length === 0)} />
              </Table>
          </Stack>

          </Card>
        :
        <LoadingScreen sx={{ height:'600px'}}/>
      }
    </Container>  )


}
